import moment from 'moment';

export const DOSSIER_CONTACTMOMENTS_RESOURCE = {
  key: 'DOSSIER_CONTACTMOMENTS_RESOURCE',
  table: {
    title: 'Contactmomenten',
    emptyMessage: 'Er zijn momenteel nog geen contactmomenten toegevoegd.',
    defaultSort: 'date',
    dataLocation: '_embedded.static',
    disablePagination: true,
    dataTransform: (data) =>
      data?.map((i) => {
        return {
          ...i,
          date: moment(i?.date).format('DD/MM/YYYY')
        };
      }),
    fields: [
      { value: 'date', label: 'Datum contacmoment', show: true, order: 0 },
      { value: 'subject', label: 'Onderwerp', show: true, order: 1 },
      { value: 'duration', label: 'Duurtijd', show: true, order: 2 }
    ]
  }
};
